import type { ReactElement } from 'react';

import { RoutineCategory, DayMode } from '../../domain/routine/enums';
import {
  BrainIcon,
  CalendarCheckIcon,
  ClockIcon,
  CompassIcon,
  DumbbellIcon,
  HeartHandshakeIcon,
  HeartIcon,
  HeartPulseIcon,
  LayersIcon,
  MoonIcon,
  MountainIcon,
  NotebookPenIcon,
  PlaneIcon,
  SproutIcon,
  SunIcon,
  TargetIcon,
  ZapIcon,
  type IconProps,
} from './index';

type IconComponent = (props: IconProps) => ReactElement;

export const CATEGORY_ICONS: Record<RoutineCategory, IconComponent> = {
  [RoutineCategory.mental]: BrainIcon,
  [RoutineCategory.sport]: DumbbellIcon,
  [RoutineCategory.health]: HeartPulseIcon,
  [RoutineCategory.work]: TargetIcon,
  [RoutineCategory.organization]: CalendarCheckIcon,
  [RoutineCategory.growth]: SproutIcon,
  [RoutineCategory.emotion]: HeartIcon,
  [RoutineCategory.relationship]: HeartHandshakeIcon,
  [RoutineCategory.journal]: NotebookPenIcon,
  [RoutineCategory.custom]: CompassIcon,
};

/**
 * Legacy generic-icon mapping used only by screens outside the ASCEND redesign scope
 * (e.g. HistoryPage). The redesigned "Aujourd'hui" screen uses the ASCEND `Icon` component
 * with its own local SVGs and never these — see design-system/core/Icon.tsx.
 */
export const MODE_ICONS: Record<DayMode, IconComponent> = {
  [DayMode.normal]: SunIcon,
  [DayMode.busy]: ZapIcon,
  [DayMode.travel]: PlaneIcon,
  [DayMode.recovery]: MoonIcon,
  [DayMode.difficult]: MountainIcon,
  [DayMode.elevation]: LayersIcon,
  [DayMode.momentDecisif]: TargetIcon,
  [DayMode.imprevu]: CompassIcon,
  [DayMode.transition]: ClockIcon,
};
